const Countries = [
    {
        value: 'AF',
        text: 'Afganistán'
    },
    {
        value: 'AL',
        text: 'Albania'
    },
    {
        value: 'DE',
        text: 'Alemania'
    },
    {
        value: 'AD',
        text: 'Andorra'
    },
    {
        value: 'AO',
        text: 'Angola'
    },
    {
        value: 'AI',
        text: 'Anguilla'
    },
    {
        value: 'AQ',
        text: 'Antártida'
    },
    {
        value: 'AG',
        text: 'Antigua y Barbuda'
    },
    {
        value: 'AN',
        text: 'Antillas Holandesas'
    },
    {
        value: 'SA',
        text: 'Arabia Saudí'
    },
    {
        value: 'DZ',
        text: 'Argelia'
    },
    {
        value: 'AR',
        text: 'Argentina'
    },
    {
        value: 'AM',
        text: 'Armenia'
    },
    {
        value: 'AW',
        text: 'Aruba'
    },
    {
        value: 'AU',
        text: 'Australia'
    },
    {
        value: 'AT',
        text: 'Austria'
    },
    {
        value: 'AZ',
        text: 'Azerbaiyán'
    },
    {
        value: 'BS',
        text: 'Bahamas'
    },
    {
        value: 'BH',
        text: 'Bahrein'
    },
    {
        value: 'BD',
        text: 'Bangladesh'
    },
    {
        value: 'BB',
        text: 'Barbados'
    },
    {
        value: 'BE',
        text: 'Bélgica'
    },
    {
        value: 'BZ',
        text: 'Belice'
    },
    {
        value: 'BJ',
        text: 'Benin'
    },
    {
        value: 'BM',
        text: 'Bermudas'
    },
    {
        value: 'BY',
        text: 'Bielorrusia'
    },
    {
        value: 'MM',
        text: 'Birmania'
    },
    {
        value: 'BO',
        text: 'Bolivia'
    },
    {
        value: 'BA',
        text: 'Bosnia y Herzegovina'
    },
    {
        value: 'BW',
        text: 'Botswana'
    },
    {
        value: 'BR',
        text: 'Brasil'
    },
    {
        value: 'BN',
        text: 'Brunei'
    },
    {
        value: 'BG',
        text: 'Bulgaria'
    },
    {
        value: 'BF',
        text: 'Burkina Faso'
    },
    {
        value: 'BI',
        text: 'Burundi'
    },
    {
        value: 'BT',
        text: 'Bután'
    },
    {
        value: 'CV',
        text: 'Cabo Verde'
    },
    {
        value: 'KH',
        text: 'Camboya'
    },
    {
        value: 'CM',
        text: 'Camerún'
    },
    {
        value: 'CA',
        text: 'Canadá'
    },
    {
        value: 'TD',
        text: 'Chad'
    },
    {
        value: 'CL',
        text: 'Chile'
    },
    {
        value: 'CN',
        text: 'China'
    },
    {
        value: 'CY',
        text: 'Chipre'
    },
    {
        value: 'VA',
        text: 'Ciudad del Vaticano (Santa Sede)'
    },
    {
        value: 'CO',
        text: 'Colombia'
    },
    {
        value: 'KM',
        text: 'Comores'
    },
    {
        value: 'CG',
        text: 'Congo'
    },
    {
        value: 'CD',
        text: 'Congo, República Democrática del'
    },
    {
        value: 'KR',
        text: 'Corea'
    },
    {
        value: 'KP',
        text: 'Corea del Norte'
    },
    {
        value: 'CI',
        text: 'Costa de Marfíl'
    },
    {
        value: 'CR',
        text: 'Costa Rica'
    },
    {
        value: 'HR',
        text: 'Croacia (Hrvatska)'
    },
    {
        value: 'CU',
        text: 'Cuba'
    },
    {
        value: 'DK',
        text: 'Dinamarca'
    },
    {
        value: 'DJ',
        text: 'Djibouti'
    },
    {
        value: 'DM',
        text: 'Dominica'
    },
    {
        value: 'EC',
        text: 'Ecuador'
    },
    {
        value: 'EG',
        text: 'Egipto'
    },
    {
        value: 'SV',
        text: 'El Salvador'
    },
    {
        value: 'AE',
        text: 'Emiratos Árabes Unidos'
    },
    {
        value: 'ER',
        text: 'Eritrea'
    },
    {
        value: 'SI',
        text: 'Eslovenia'
    },
    {
        value: 'ES',
        text: 'España'
    },
    {
        value: 'US',
        text: 'Estados Unidos'
    },
    {
        value: 'EE',
        text: 'Estonia'
    },
    {
        value: 'ET',
        text: 'Etiopía'
    },
    {
        value: 'FJ',
        text: 'Fiji'
    },
    {
        value: 'PH',
        text: 'Filipinas'
    },
    {
        value: 'FI',
        text: 'Finlandia'
    },
    {
        value: 'FR',
        text: 'Francia'
    },
    {
        value: 'GA',
        text: 'Gabón'
    },
    {
        value: 'GM',
        text: 'Gambia'
    },
    {
        value: 'GE',
        text: 'Georgia'
    },
    {
        value: 'GH',
        text: 'Ghana'
    },
    {
        value: 'GI',
        text: 'Gibraltar'
    },
    {
        value: 'GD',
        text: 'Granada'
    },
    {
        value: 'GR',
        text: 'Grecia'
    },
    {
        value: 'GL',
        text: 'Groenlandia'
    },
    {
        value: 'GP',
        text: 'Guadalupe'
    },
    {
        value: 'GU',
        text: 'Guam'
    },
    {
        value: 'GT',
        text: 'Guatemala'
    },
    {
        value: 'GY',
        text: 'Guayana'
    },
    {
        value: 'GF',
        text: 'Guayana Francesa'
    },
    {
        value: 'GN',
        text: 'Guinea'
    },
    {
        value: 'GQ',
        text: 'Guinea Ecuatorial'
    },
    {
        value: 'GW',
        text: 'Guinea-Bissau'
    },
    {
        value: 'HT',
        text: 'Haití'
    },
    {
        value: 'HN',
        text: 'Honduras'
    },
    {
        value: 'HU',
        text: 'Hungría'
    },
    {
        value: 'IN',
        text: 'India'
    },
    {
        value: 'ID',
        text: 'Indonesia'
    },
    {
        value: 'IQ',
        text: 'Irak'
    },
    {
        value: 'IR',
        text: 'Irán'
    },
    {
        value: 'IE',
        text: 'Irlanda'
    },
    {
        value: 'BV',
        text: 'Isla Bouvet'
    },
    {
        value: 'CX',
        text: 'Isla de Christmas'
    },
    {
        value: 'IS',
        text: 'Islandia'
    },
    {
        value: 'KY',
        text: 'Islas Caimán'
    },
    {
        value: 'CK',
        text: 'Islas Cook'
    },
    {
        value: 'CC',
        text: 'Islas de Cocos o Keeling'
    },
    {
        value: 'FO',
        text: 'Islas Faroe'
    },
    {
        value: 'HM',
        text: 'Islas Heard y McDonald'
    },
    {
        value: 'FK',
        text: 'Islas Malvinas'
    },
    {
        value: 'MP',
        text: 'Islas Marianas del Norte'
    },
    {
        value: 'MH',
        text: 'Islas Marshall'
    },
    {
        value: 'UM',
        text: 'Islas menores de Estados Unidos'
    },
    {
        value: 'PW',
        text: 'Islas Palau'
    },
    {
        value: 'SB',
        text: 'Islas Salomón'
    },
    {
        value: 'SJ',
        text: 'Islas Svalbard y Jan Mayen'
    },
    {
        value: 'TK',
        text: 'Islas Tokelau'
    },
    {
        value: 'TC',
        text: 'Islas Turks y Caicos'
    },
    {
        value: 'VI',
        text: 'Islas Vírgenes (EEUU)'
    },
    {
        value: 'VG',
        text: 'Islas Vírgenes (Reino Unido)'
    },
    {
        value: 'WF',
        text: 'Islas Wallis y Futuna'
    },
    {
        value: 'IL',
        text: 'Israel'
    },
    {
        value: 'IT',
        text: 'Italia'
    },
    {
        value: 'JM',
        text: 'Jamaica'
    },
    {
        value: 'JP',
        text: 'Japón'
    },
    {
        value: 'JO',
        text: 'Jordania'
    },
    {
        value: 'KZ',
        text: 'Kazajistán'
    },
    {
        value: 'KE',
        text: 'Kenia'
    },
    {
        value: 'KG',
        text: 'Kirguizistán'
    },
    {
        value: 'KI',
        text: 'Kiribati'
    },
    {
        value: 'KW',
        text: 'Kuwait'
    },
    {
        value: 'LA',
        text: 'Laos'
    },
    {
        value: 'LS',
        text: 'Lesotho'
    },
    {
        value: 'LV',
        text: 'Letonia'
    },
    {
        value: 'LB',
        text: 'Líbano'
    },
    {
        value: 'LR',
        text: 'Liberia'
    },
    {
        value: 'LY',
        text: 'Libia'
    },
    {
        value: 'LI',
        text: 'Liechtenstein'
    },
    {
        value: 'LT',
        text: 'Lituania'
    },
    {
        value: 'LU',
        text: 'Luxemburgo'
    },
    {
        value: 'MK',
        text: 'Macedonia, Ex-República Yugoslava de'
    },
    {
        value: 'MG',
        text: 'Madagascar'
    },
    {
        value: 'MY',
        text: 'Malasia'
    },
    {
        value: 'MW',
        text: 'Malawi'
    },
    {
        value: 'MV',
        text: 'Maldivas'
    },
    {
        value: 'ML',
        text: 'Malí'
    },
    {
        value: 'MT',
        text: 'Malta'
    },
    {
        value: 'MA',
        text: 'Marruecos'
    },
    {
        value: 'MQ',
        text: 'Martinica'
    },
    {
        value: 'MU',
        text: 'Mauricio'
    },
    {
        value: 'MR',
        text: 'Mauritania'
    },
    {
        value: 'YT',
        text: 'Mayotte'
    },
    {
        value: 'MX',
        text: 'México'
    },
    {
        value: 'FM',
        text: 'Micronesia'
    },
    {
        value: 'MD',
        text: 'Moldavia'
    },
    {
        value: 'MC',
        text: 'Mónaco'
    },
    {
        value: 'MN',
        text: 'Mongolia'
    },
    {
        value: 'MS',
        text: 'Montserrat'
    },
    {
        value: 'MZ',
        text: 'Mozambique'
    },
    {
        value: 'NA',
        text: 'Namibia'
    },
    {
        value: 'NR',
        text: 'Nauru'
    },
    {
        value: 'NP',
        text: 'Nepal'
    },
    {
        value: 'NI',
        text: 'Nicaragua'
    },
    {
        value: 'NE',
        text: 'Níger'
    },
    {
        value: 'NG',
        text: 'Nigeria'
    },
    {
        value: 'NU',
        text: 'Niue'
    },
    {
        value: 'NF',
        text: 'Norfolk'
    },
    {
        value: 'NO',
        text: 'Noruega'
    },
    {
        value: 'NC',
        text: 'Nueva Caledonia'
    },
    {
        value: 'NZ',
        text: 'Nueva Zelanda'
    },
    {
        value: 'OM',
        text: 'Omán'
    },
    {
        value: 'NL',
        text: 'Países Bajos'
    },
    {
        value: 'PA',
        text: 'Panamá'
    },
    {
        value: 'PG',
        text: 'Papúa Nueva Guinea'
    },
    {
        value: 'PK',
        text: 'Paquistán'
    },
    {
        value: 'PY',
        text: 'Paraguay'
    },
    {
        value: 'PE',
        text: 'Perú'
    },
    {
        value: 'PN',
        text: 'Pitcairn'
    },
    {
        value: 'PF',
        text: 'Polinesia Francesa'
    },
    {
        value: 'PL',
        text: 'Polonia'
    },
    {
        value: 'PT',
        text: 'Portugal'
    },
    {
        value: 'PR',
        text: 'Puerto Rico'
    },
    {
        value: 'QA',
        text: 'Qatar'
    },
    {
        value: 'UK',
        text: 'Reino Unido'
    },
    {
        value: 'CF',
        text: 'República Centroafricana'
    },
    {
        value: 'CZ',
        text: 'República Checa'
    },
    {
        value: 'ZA',
        text: 'República de Sudáfrica'
    },
    {
        value: 'DO',
        text: 'República Dominicana'
    },
    {
        value: 'SK',
        text: 'República Eslovaca'
    },
    {
        value: 'RE',
        text: 'Reunión'
    },
    {
        value: 'RW',
        text: 'Ruanda'
    },
    {
        value: 'RO',
        text: 'Rumania'
    },
    {
        value: 'RU',
        text: 'Rusia'
    },
    {
        value: 'EH',
        text: 'Sahara Occidental'
    },
    {
        value: 'KN',
        text: 'Saint Kitts y Nevis'
    },
    {
        value: 'WS',
        text: 'Samoa'
    },
    {
        value: 'AS',
        text: 'Samoa Americana'
    },
    {
        value: 'SM',
        text: 'San Marino'
    },
    {
        value: 'VC',
        text: 'San Vicente y Granadinas'
    },
    {
        value: 'SH',
        text: 'Santa Helena'
    },
    {
        value: 'LC',
        text: 'Santa Lucía'
    },
    {
        value: 'ST',
        text: 'Santo Tomé y Príncipe'
    },
    {
        value: 'SN',
        text: 'Senegal'
    },
    {
        value: 'SC',
        text: 'Seychelles'
    },
    {
        value: 'SL',
        text: 'Sierra Leona'
    },
    {
        value: 'SG',
        text: 'Singapur'
    },
    {
        value: 'SY',
        text: 'Siria'
    },
    {
        value: 'SO',
        text: 'Somalia'
    },
    {
        value: 'LK',
        text: 'Sri Lanka'
    },
    {
        value: 'PM',
        text: 'St Pierre y Miquelon'
    },
    {
        value: 'SZ',
        text: 'Suazilandia'
    },
    {
        value: 'SD',
        text: 'Sudán'
    },
    {
        value: 'SE',
        text: 'Suecia'
    },
    {
        value: 'CH',
        text: 'Suiza'
    },
    {
        value: 'SR',
        text: 'Surinam'
    },
    {
        value: 'TH',
        text: 'Tailandia'
    },
    {
        value: 'TW',
        text: 'Taiwán'
    },
    {
        value: 'TZ',
        text: 'Tanzania'
    },
    {
        value: 'TJ',
        text: 'Tayikistán'
    },
    {
        value: 'TF',
        text: 'Territorios franceses del Sur'
    },
    {
        value: 'TP',
        text: 'Timor Oriental'
    },
    {
        value: 'TG',
        text: 'Togo'
    },
    {
        value: 'TO',
        text: 'Tonga'
    },
    {
        value: 'TT',
        text: 'Trinidad y Tobago'
    },
    {
        value: 'TN',
        text: 'Túnez'
    },
    {
        value: 'TM',
        text: 'Turkmenistán'
    },
    {
        value: 'TR',
        text: 'Turquía'
    },
    {
        value: 'TV',
        text: 'Tuvalu'
    },
    {
        value: 'UA',
        text: 'Ucrania'
    },
    {
        value: 'UG',
        text: 'Uganda'
    },
    {
        value: 'UY',
        text: 'Uruguay'
    },
    {
        value: 'UZ',
        text: 'Uzbekistán'
    },
    {
        value: 'VU',
        text: 'Vanuatu'
    },
    {
        value: 'VE',
        text: 'Venezuela'
    },
    {
        value: 'VN',
        text: 'Vietnam'
    },
    {
        value: 'YE',
        text: 'Yemen'
    },
    {
        value: 'YU',
        text: 'Yugoslavia'
    },
    {
        value: 'ZM',
        text: 'Zambia'
    },
    {
        value: 'ZW',
        text: 'Zimbabue'
    }
]

export {
    Countries
}
